export enum Feature {
  FEATURE_EXAMPLE = 'FEATURE_EXAMPLE',
  LANDLORD_SECTION = 'LANDLORD_SECTION',
  TENANT_NETWORK_WIDGET = 'TENANT_NETWORK_WIDGET',
  WOMENS_DAY_VOUCHER_MODAL = 'WOMENS_DAY_VOUCHER_MODAL',
  WOHNEN_PLUS_LIGHT = 'WOHNEN_PLUS_LIGHT',
  BLOCK_WOHNEN_PLUS_LIGHT_UPSELL_ANDROID = 'BLOCK_WOHNEN_PLUS_LIGHT_UPSELL_ANDROID',
  BIZ_9847_ANDROID_EXTERNAL_TRANSACTION_TOKEN = 'BIZ_9847_ANDROID_EXTERNAL_TRANSACTION_TOKEN',
  BIZ_9692_ENABLE_UPGRADE_TOUCHPOINT = 'BIZ_9692_ENABLE_UPGRADE_TOUCHPOINT',
}

export interface FeatureSwitch {
  feature: Feature;
  enabled: boolean;
}

export interface FeatureSwitches {
  features: FeatureSwitch[];
}
